import {
  factory as biLoggerFactory,
  Logger,
  LogParams,
} from '@wix/fe-essentials-editor/bi';

let loggerInstance: Logger;

const BI_PLATFORM_HOST_INTEGRATION_ENDPOINT = 'editor-platform';
const BI_PLATFORM_HOST_INTEGRATION_SRC = 164;
export const PLATFORM_INIT = 122;
export const PLATFORM_ERROR = 121;

let pendingEventsQueue: LogParams[] = []; // for storing events fired before logger initialization

function logPendingEvents(logger: Logger) {
  if (!pendingEventsQueue.length) {
    return;
  }

  pendingEventsQueue.forEach((eventParams) => {
    logger.log(eventParams);
  });

  pendingEventsQueue = [];
}

export function createBiLogger({
  userId,
  metaSiteId,
  editorType,
  editorSessionId,
  sdkInfo,
  endpoint = BI_PLATFORM_HOST_INTEGRATION_ENDPOINT,
  src = BI_PLATFORM_HOST_INTEGRATION_SRC,
  targetAccountId,
}: {
  userId: string;
  metaSiteId: string;
  editorSessionId: string;
  editorType?: string;
  sdkInfo?: { sdkVersion?: string };
  endpoint?: string;
  src?: number;
  targetAccountId?: string;
}) {
  loggerInstance = biLoggerFactory({
    endpoint,
  })
    .updateDefaults({
      src,
      msid: metaSiteId,
      uuid: userId,
      esi: editorSessionId,
      sdkVersion: sdkInfo?.sdkVersion,
      editorType,
      target_account_id: targetAccountId,
    })
    .logger();

  logPendingEvents(loggerInstance);

  return loggerInstance;
}

export function reportBi(evid: number, event: Record<string, any>) {
  const eventParams = { ...event, evid };
  if (loggerInstance) {
    loggerInstance.log(eventParams);
  } else {
    pendingEventsQueue.push(eventParams);
  }
}
